import * as React from 'react';
import { useState } from 'react';
import templates from '../../data/templates';
import KiteMeta from '../components/KiteMeta';
import KiteModel from '../components/KiteModel';
import Search from '../components/Search';
import useKites from '../hooks/useKites';
import { Session } from '../services/Store';
import { TemplateKey } from '../types';

export default function TemplatesPage() {
    const { add } = useKites();

    function handleCreate(template: TemplateKey, variation?: string) {
        add(template, variation);
        Session.setPage('kite');
    }

    const [search, setSearch] = useState('');

    return (
        <div className="template-list">
            <Search
                search={search}
                setSearch={setSearch}
                placeholder="search in template names"
            />
            {Object.entries(templates)
                .filter(([, template]) => {
                    return new RegExp(search, 'ig').test(template.meta.name);
                })
                .sort(([, a], [, b]) => (a.meta.name > b.meta.name ? 1 : -1))
                .map(([key, template]) => (
                    <div key={key} className="template-list__item">
                        <div className="template-list__meta">
                            <KiteMeta templateKey={key} />
                            {template.variations ? (
                                <>
                                    <span className="label">create</span>
                                    <div className="buttongroup">
                                        {template.variations.map(
                                            (variation) => (
                                                <button
                                                    key={variation}
                                                    onClick={() =>
                                                        handleCreate(
                                                            key,
                                                            variation
                                                        )
                                                    }
                                                >
                                                    {variation}
                                                </button>
                                            )
                                        )}
                                    </div>
                                </>
                            ) : (
                                <button onClick={() => handleCreate(key)}>
                                    create
                                </button>
                            )}
                        </div>
                        <div className="template-list__kite">
                            <KiteModel
                                svg={template.svg}
                                templateKey={key}
                                removeStyle
                                simple
                            />
                        </div>
                    </div>
                ))}
        </div>
    );
}
